/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_Effort_LimitInputs */

const en_us2_workout_quick_effort_limit = /** @type {(inputs: Workout_Quick_Effort_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All out`)
};

const pt_br2_workout_quick_effort_limit = /** @type {(inputs: Workout_Quick_Effort_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No limite`)
};

const es_419_workout_quick_effort_limit = /** @type {(inputs: Workout_Quick_Effort_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al límite`)
};

const pt_pt2_workout_quick_effort_limit = /** @type {(inputs: Workout_Quick_Effort_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No limite`)
};

const fr_fr2_workout_quick_effort_limit = /** @type {(inputs: Workout_Quick_Effort_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À fond`)
};

const de_de2_workout_quick_effort_limit = /** @type {(inputs: Workout_Quick_Effort_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Am Limit`)
};

const it_it2_workout_quick_effort_limit = /** @type {(inputs: Workout_Quick_Effort_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al limite`)
};

/**
* | output |
* | --- |
* | "All out" |
*
* @param {Workout_Quick_Effort_LimitInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_effort_limit = /** @type {((inputs?: Workout_Quick_Effort_LimitInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_Effort_LimitInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_effort_limit(inputs)
	if (locale === "es-419") return es_419_workout_quick_effort_limit(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_effort_limit(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_effort_limit(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_effort_limit(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_effort_limit(inputs)
	return en_us2_workout_quick_effort_limit(inputs)
});
export { workout_quick_effort_limit as "workout-quick.effort_limit" }